module.exports = __webpack_public_path__ + "static/HSE_ESG_Report2024-2554b09cfef31466e0b11dcb065872cb.pdf";